<template>
	<div class="content my-0 py-1">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12  mt-2 py-0">
					<h4 class="m-0 p-0 text-secondary d-inline">Invoice</h4>
					<button class="float-right btn btn-primary shadow"
					        v-on:click="formInvoiceAirtimeActive=!formInvoiceAirtimeActive">Tambah Invoice Baru
					</button>
				</div>
				<transition name="fade">
					<div class="col-12  my-2 py-0" v-if="formInvoiceAirtimeActive">
						<div class="row p-3 mx-2 bg-white shadow">
							<div class="col-12 mb-3">
								<h4 class="my-0 py-0">Form Invoice</h4>
								<hr>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">ID transmitter</label>
								<smart-search init url="/api/seeker/sold-hardware-setup" :label-tag="['id_transmitter']"
								              key-tag="id_transmitter"
								              v-on:update="(data)=>smartSearchAddIdTransmitter(data)"
								              :search-value="newhardwareidlabel"
								              @update-direct="(label)=>newhardwareidlabel=label"></smart-search>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Serial number</label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.serial_number != undefined && selectedHardwareSetup.serial_number != null ? selectedHardwareSetup.serial_number.serial_number : "-"
									}}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">No JB</label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.jb != undefined && selectedHardwareSetup.jb != null ? selectedHardwareSetup.jb.serial_number : "-"
									}}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Nama kapal</label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.vessel != undefined && selectedHardwareSetup.vessel.name != null ? selectedHardwareSetup.vessel.name : "-"
									}}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Pemilik</label>
								<div class="form-control w-100 rounded">
									{{
										selectedHardwareSetup.vessel != undefined && selectedHardwareSetup.vessel.client.legal_name != null ? selectedHardwareSetup.vessel.client.legal_name : "-"
									}}
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Nomor Invoice</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newInvoiceAirtime.invoiceNo"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Tanggal invoice</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-invoice-date" v-model="newInvoiceAirtime.invoiceDate" class="mb-2">
									{{ newInvoiceAirtime.invoiceDate }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Tanggal invoice jatuh tempo</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-due-date" v-model="newInvoiceAirtime.dueDateInvoice" class="mb-2">
									{{ newInvoiceAirtime.dueDateInvoice }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Tanggal aktivasi</label>
								<b-form-datepicker today-button reset-button close-button
									:date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
									id="datepicker-start-period" v-model="newInvoiceAirtime.startPeriod" class="mb-2">
									{{ newInvoiceAirtime.startPeriod }}
								</b-form-datepicker>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2" v-if="false">
								<label class="d-block">Proforma</label>
								<smart-select name="proforma" :options="proformaTypeOptions"
								              v-on:update="updateNewIiProforma"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">QR Code</label>
								<smart-select name="qr_code" :options="qrCodeTypeOptions"
								              v-on:update="updateNewQrCode"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Harga</label>
								<smart-search init url="/api/master/seeker/airtime-price"
								              :label-tag="['name_airtime_price']" key-tag="name_airtime_price"
								              v-on:update="(data)=>smartSearchAirtimePrice(data)"
								              :search-value="newairtimepricelabel"
								              @update-direct="(label)=>newairtimepricelabel=label"
								              @input="calculateAmount"></smart-search>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Durasi airtime</label>
								<div class="form-control w-100 rounded">{{ newInvoiceAirtime.airtimeMonthDuration }}
									Bulan
								</div>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">PPN</label>
								<smart-select name="ppn" :options="ppnTypeOptions"
								              v-on:update="updateNewPpn"></smart-select>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Diskon</label>
								<smart-search init url="/api/master/seeker/discount" :label-tag="['discount']"
								              key-tag="discount" @clear="smartSearchDiscount(null)"
								              v-on:update="(data)=>smartSearchDiscount(data)"
								              :search-value="newairtimediskonlabel"
								              @update-direct="(label)=>newairtimediskonlabel=label"></smart-search>
							</div>
		                    <div class="col-12 col-md-6 col-lg-4 mt-2">
		                      <label class="d-block">Account Bank</label>
			                    <smart-search 
			                    :search-value="newInvoiceAirtime.label_bank" init url="/api/master/seeker/bank" usedefault :default-value="newInvoiceAirtime.label_bank" key-tag="nama" v-on:update="(data)=>{newInvoiceAirtime.id_bank=data.id}"  @update-direct="(label)=>newInvoiceAirtime.label_bank=label"></smart-search>
		                    </div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">PIC</label>
								<input type="text" class="form-control w-100 rounded" v-model="newInvoiceAirtime.pic"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Jabatan</label>
								<input type="text" class="form-control w-100 rounded"
								       v-model="newInvoiceAirtime.division"/>
							</div>
							<div class="col-12 col-md-6 col-lg-4 mt-2">
								<label class="d-block">Keterangan</label>
								<textarea type="text" class="form-control w-100 rounded"
								          v-model="newInvoiceAirtime.notes"/>
							</div>
							<div class="col-12 mt-2">
								<br><br>
								<hr>
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Harga</label>
									<div type="text" class="form-control col-12 col-md-6  text-right w-100 rounded">
										{{ newInvoiceAirtime.airtimePrice | numeral("0,0") }}
									</div>
								</div>
							</div>
							<div class="col-12 mt-2">
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Diskon</label>
									<div type="text" class="col-12 col-md-6 form-control text-right w-100 rounded">
										-{{ newInvoiceAirtime.discount | numeral("0,0") }}
									</div>
								</div>
							</div>
							<div class="col-12 mt-2">
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Sub total</label>
									<div type="text" class="col-12 col-md-6 form-control text-right w-100 rounded">
										{{ newInvoiceAirtime.subtotal | numeral("0,0") }}
									</div>
								</div>
							</div>
							<div class="col-12 mt-2">
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Total PPN</label>
									<div type="text" class="col-12 col-md-6 form-control text-right w-100 rounded">
										{{ newInvoiceAirtime.totalPPN | numeral("0,0") }}
									</div>
								</div>
							</div>
							<div class="col-12 mt-2">
								<div class="row">
									<label class="d-block col-12 col-md-6 text-right">Total</label>
									<div type="text" class="form-control w-100 col-12 text-right col-md-6 rounded">
										<b>{{ newInvoiceAirtime.total | numeral("0,0") }}</b>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="newInvoiceAirtimeSaved">
									<div class="alert alert-success" role="alert">
										Berhasil Menyimpan Invoice Baru.
									</div>
								</div>
							</div>

							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start"
								     v-if="errorNewInvoiceAirtime">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1">Gagal Menyimpan Invoice Baru.</p>
										</div>
										<div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start"
								     v-if="savingNewInvoiceAirtime">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-primary float-right" type="button"
								        v-on:click="savenewInvoiceAirtime">Submit
								</button>
							</div>
						</div>
					</div>
				</transition>


				<div class="col-12  my-2 py-0">
					<datatable :currentIdx="currentPage" :datas="invoiceairtimes"
					           :structure="tableStructure" :init="loadData"
					           :next-url="nextUrl" :prev-url="prevUrl" @change-page="(isNext)=>{changePage(isNext)}"
					           use-filter use-seeker seeker-url="/api/pemesanan/seeker/invoice-airtime"
					           use-xml xml-url="/api/xml/invoice-airtime"
					           @refetch="(row)=>{rowLimit=row;getInvoiceAirtimes()}"
					           @searching="(val)=>!val.status?getInvoiceAirtimes():invoiceairtimes=val.data">
						<template #customcell={obj,index}>
							<td>{{ ((currentPage - 1) * perPage) + index + 1  }}</td>
							<td>{{ obj.invoice_no }}</td>
							<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name }}
							</td>
							<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.client.npwp }}</td>
							<td>{{ obj.invoice_date | timeformat }}</td>
							<td>{{ obj.start_period | timeformat }}</td>
							<td>{{ obj.end_periode | timeformat }}</td>
							<td>{{ obj.invoice_item_metadata.order_metadata.hardware_setup.vessel.name }}</td>
							<td>
								<b-button v-b-modal.modal-sap class="btn btn-success"
								          :href="'https://api-billing.megahsurya.com/api/invoice/airtime-sap/'+obj.id">
									<b>SAP</b></b-button>
							</td>
							<td>
								<b-button class="btn btn-warning mr-2 mb-1"
								          :href="'https://api-billing.megahsurya.com/api/invoice/airtime/'+obj.id+'?qr=yes'"
								          title="Invoice">
									<b-icon icon="printer"></b-icon>
								</b-button>
								<b-button class="btn btn-secondary mr-2 mb-1"
								          :href="'https://api-billing.megahsurya.com/api/invoice/airtime/'+obj.id+'?proforma=yes&qr=yes'"
								          title="Proforma invoice">
									<b-icon icon="printer"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-detail-histories class="btn btn-success mr-2 mb-1"
								          v-on:click="getHistories(obj.id)" title="History">
									<b-icon icon="clock-history"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-detail-invoice-airtime class="btn btn-primary mr-2 mb-1"
								          v-on:click="selectedDetail=index" title="View">
									<b-icon icon="eye"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-edit-invoice class="btn btn-info mr-2 mb-1"
								          v-if="['master_admin','admin'].includes(role)" title="Edit">
									<b-icon icon="pencil-square"></b-icon>
								</b-button>
								<b-button v-b-modal.modal-delete v-on:click="deleteId=obj.id;itemToDelete=obj"
								          class="btn btn-danger mr-2 mb-1"
								          v-if="['master_admin','admin'].includes(role)" title="Delete">
									<b-icon icon="trash"></b-icon>
								</b-button>
							</td>
						</template>
					</datatable>
				</div>

				<b-modal id="modal-edit-invoice" title="Edit data" scrollable no-close-on-backdrop size="lg"
				         v-if="invoiceairtimes.length>0">
					<div class="row" v-if="invoiceairtimes[selectedIdforEdit]!=undefined">
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">ID transmitter</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.id_transmitter
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Serial number</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.serial_number != null
											? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number
											: "-"
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">No JB</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.jb != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.jb.serial_number
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Nama kapal</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined
									&& invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null
										? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.vessel.name
										: "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Pemilik</label>
							<div class="form-control w-100 rounded">
								{{
									invoiceairtimes[selectedIdforEdit].invoice_item_metadata != undefined && invoiceairtimes[selectedIdforEdit].invoice_item_metadata != null ? invoiceairtimes[selectedIdforEdit].invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name : "-"
								}}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Nomor Invoice</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceairtimes[selectedIdforEdit].invoice_no"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Tanggal invoice</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-invoice-date"
							                   v-model="invoiceairtimes[selectedIdforEdit].invoice_date" class="mb-2">
								{{ invoiceairtimes[selectedIdforEdit].invoice_date }}
							</b-form-datepicker>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Tanggal invoice jatuh tempo</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-due-date"
							                   v-model="invoiceairtimes[selectedIdforEdit].due_date_invoice"
							                   class="mb-2">{{ invoiceairtimes[selectedIdforEdit].due_date_invoice }}
							</b-form-datepicker>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Tanggal aktivasi</label>
							<b-form-datepicker today-button reset-button close-button :date-format-options="{day: 'numeric', month: 'short', year: 'numeric'}"
							                   id="datepicker-start-period"
							                   v-model="invoiceairtimes[selectedIdforEdit].start_period" class="mb-2">
								{{ invoiceairtimes[selectedIdforEdit].start_period }}
							</b-form-datepicker>
						</div>
						<!-- <div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Buat proforma</label>
							<smart-select name="proforma" :options="proformaTypeOptions" usedefault :default-value="invoiceairtimes[selectedIdforEdit].proforma" v-on:update="(value)=>{invoiceairtimes[selectedIdforEdit].proforma=value}"></smart-select>
						</div> -->
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">QR code</label>
							<smart-select name="qr_code" :options="qrCodeTypeOptions" usedefault
							              :default-value="invoiceairtimes[selectedIdforEdit].proforma"
							              v-on:update="(value)=>{invoiceairtimes[selectedIdforEdit].qr_code=value}"></smart-select>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Harga</label>
							<smart-search init url="/api/master/seeker/airtime-price" usedefault
							              :default-value="invoiceairtimes[selectedIdforEdit].name_airtime_price"
							              @clear="smartSearchUpdateAirtimePrice(null)" key-tag="name_airtime_price"
							              v-on:update="(data)=>smartSearchUpdateAirtimePrice(data)"></smart-search>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Diskon</label>
							<smart-search init url="/api/master/seeker/discount" usedefault
							              :default-value="invoiceairtimes[selectedIdforEdit].discount"
							              key-tag="discount" @clear="smartSearchUpdateDiscount(null)"
							              v-on:update="(data)=>smartSearchUpdateDiscount(data)"></smart-search>
						</div>
	                    <div class="col-12 col-md-6 col-lg-4 mt-2">
	                      <label class="d-block">Account Bank</label>
	                      <smart-search 
	                      :search-value="newInvoiceAirtime.label_bank" init url="/api/master/seeker/bank" usedefault :default-value="invoiceairtimes[selectedIdforEdit].bank == null ?'' : invoiceairtimes[selectedIdforEdit].bank.nama" key-tag="nama" v-on:update="(data)=>{invoiceairtimes[selectedIdforEdit].id_bank=data.id}"  @update-direct="(label)=>newInvoiceAirtime.label_bank=label"></smart-search>
	                    </div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Total airtime</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].airtime_price | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Total discount</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].discount | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2"
						     v-if="this.invoiceairtimes[this.selectedIdforEdit].totalPPN!=undefined">
							<label class="d-block">Sub Total</label>
							<!-- <input type="text"  class="form-control w-100 rounded" v-model="invoiceairtimes[selectedIdforEdit].subtotal" readonly/> -->
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].subtotal | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PPN</label>
							<smart-select name="ppn" :options="ppnTypeOptions" usedefault
							              :default-value="invoiceairtimes[selectedIdforEdit].ppn"
							              v-on:update="(value)=>{invoiceairtimes[selectedIdforEdit].ppn=value;$forceUpdate();calculateUpdateAmount()}"></smart-select>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Total</label>
							<div class="form-control w-100 rounded">
								{{ invoiceairtimes[selectedIdforEdit].total | numeral("0,0") }}
							</div>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">PIC</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceairtimes[selectedIdforEdit].pic"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Jabatan</label>
							<input type="text" class="form-control w-100 rounded"
							       v-model="invoiceairtimes[selectedIdforEdit].division"/>
						</div>
						<div class="col-12 col-md-6 col-lg-4 mt-2">
							<label class="d-block">Keterangan</label>
							<textarea type="text" class="form-control w-100 rounded"
							          v-model="invoiceairtimes[selectedIdforEdit].notes"/>
						</div>

						<div class="col-12 mt-3">
							<div class="w-100 align-items-center justify-content-start" v-if="updateSaved">
								<div class="alert alert-success" role="alert">
									Berhasil Update Data Invoice.
								</div>
							</div>
						</div>
					</div>
					<template #modal-footer>
						<div class="w-100 text-right m-0 p-0">
							<hr>
							<div class="col-12 mt-3">
								<div class="w-100 align-items-center justify-content-start" v-if="errorUpdate">
									<div class="alert alert-danger" role="alert">
										<div class="my-0">
											<p class="d-block mt-1 text-left">Gagal update Invoice.</p>
										</div>
										<div v-for="err in errorInvoiceItemList" v-bind:key="err" class="my-0">
											<p v-for="note in err" v-bind:key="note" class="d-block mt-1">{{ note }}</p>
										</div>
									</div>
								</div>
							</div>
							<div class="col-12 mt-3">
								<div class="d-flex align-items-center justify-content-start" v-if="updating">
									<div class="spinner-border" role="status" aria-hidden="true"></div>
									<strong class=" ml-2">Menyimpan data, tunggu sebentar.</strong>
								</div>
								<button class="btn btn-info float-right" type="button"
								        v-on:click="updateInvoiceAirtime">Submit
								</button>
								<b-button class="btn btn-secondary mr-2" @click="$bvModal.hide('modal-edit-invoice')">
									close
								</b-button>
							</div>
						</div>
					</template>
				</b-modal>
			</div>
		</div>

		<b-modal no-close-on-esc content-class="m-0" size="lg" title="Detail invoice airtime"
		         id="modal-detail-invoice-airtime" scrollable no-close-on-backdrop>
			<b-container fluid v-if="!loadData&&invoiceairtimes.length>0">
				<b-row class="pt-1" v-if="invoiceairtimes[selectedDetail]!=undefined">
					<b-col cols="12">
						<table v-if="invoiceairtimes.length>0" rules="rows" class="table w-100"
						       style="overflow-x:auto;">
							<tbody>
							<tr>
								<th class="w-100 px-3 bg-secondary text-white" style="font-size:14pt" colspan="2"
								    scope="row">Detail invoice airtime
								</th>
							</tr>
							<tr>
								<th class="" scope="row">No invoice</th>
								<td class="">{{ invoiceairtimes[selectedDetail].invoice_no }}</td>
							</tr>
							<tr>
								<th class="" scope="row">ID transmitter</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.id_transmitter
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Nomor SN</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.serial_number.serial_number
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Nomor JB</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.jb != null
											? invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.jb.serial_number
											: "-"
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Nama kapal</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.vessel.name
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Pelanggan</th>
								<td class="">
									{{
										invoiceairtimes[selectedDetail].invoice_item_metadata.order_metadata.hardware_setup.vessel.client.legal_name
									}}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Tanggal invoice</th>
								<td class="">{{ invoiceairtimes[selectedDetail].invoice_date | timeformat }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Tanggal invoice jatuh tempo</th>
								<td class="">{{ invoiceairtimes[selectedDetail].due_date_invoice | timeformat }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Tanggal aktivasi</th>
								<td class="">{{ invoiceairtimes[selectedDetail].start_period | timeformat }}</td>
							</tr>
							<tr>
								<th class="" scope="row">QR code</th>
								<td class="">{{ invoiceairtimes[selectedDetail].qr_code }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Harga airtime</th>
								<td class="">{{ invoiceairtimes[selectedDetail].airtime.name_airtime_price }}</td>
							</tr>
							<tr>
								<th class="" scope="row">Harga airtime (IDR)</th>
								<td class="">Rp {{ invoiceairtimes[selectedDetail].airtime_price | numeral("0,0") }}
								</td>
							</tr>
							<tr>
								<th class="" scope="row">Harga airtime (IDR)</th>
								<td class="">Rp {{ invoiceairtimes[selectedDetail].airtime_price | numeral("0,0") }}
								</td>
							</tr>

							</tbody>

						</table>
					</b-col>
				</b-row>
			</b-container>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<b-button class="btn btn-secondary" @click="!$bvModal.hide('modal-detail-invoice-airtime')">Tutup
					</b-button>
				</div>
			</template>
		</b-modal>

		<b-modal no-close-on-esc content-class="m-0" id="modal-detail-histories" size="lg" title="Detail history"
		         scrollable no-close-on-backdrop>
			<datatable no-toolbar responsive :datas="histories" :structure="historyTableStructure"
			           :init="loadHistoriesData" use-seeker seeker-url="/api/report/json/invoice-airtime-history"
			           @searching="(val)=>!val.status?getHistories():histories=val.data">
				<template #customcell={obj,index}>
					<td v-if="isMobile" class="py-3">
						<ul style="list-style:none;width:100%;padding:0" class="rounded shadow bg-white p-2">
							<li class="mt-2">
								<div class="text-left mx-3 pt-0">
									<small class="my-0 py-0">Nama admin:</small>
									<br><b class="py-0 mx-0"
									       style="font-size:10pt">{{ obj.editor != null ? obj.editor.name : "-" }}</b>
								</div>
							</li>
						</ul>
					</td>
					<td v-if="!isMobile">{{ ((currentPage - 1) * perPage) + index + 1  }}</td>
					<td v-if="!isMobile">{{ obj.editor != null ? obj.editor.name : "-" }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).created_at | timeformat }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).invoice_no }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).invoice_date | timeformat }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).start_period | timeformat }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).invoice_date | timeformat }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).due_date | timeformat }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).cp }}</td>
					<td v-if="!isMobile">{{ JSON.parse(obj.old_data).department }}</td>
				</template>
			</datatable>
			<template #modal-footer>
				<div class="w-100 text-right m-0 p-0">
					<hr>
					<b-button class="btn btn-secondary"
					          @click="(!deleteState)?$bvModal.hide('modal-detail-histories'):''">Close
					</b-button>
				</div>
			</template>
		</b-modal>

		<modal-delete url="/api/pemesanan/invoice-airtime/" @read="()=>{console.log('modal ready')}"
		              @result="deleteResult" :targetid="deleteId">
			Yakin mau menghapus data dengan detail berikut:<br>
			<ul>
				<li>Nomor Invoice: {{ itemToDelete.invoice_no }}</li>
			</ul>
		</modal-delete>
	</div>
</template>
<script>
//   import ChartCard from 'src/components/Cards/ChartCard.vue'
//   import StatsCard from 'src/components/Cards/StatsCard.vue'
//   import LTable from 'src/components/Table.vue'
import * as axios from "axios";
import Datatable from "../../components/Datatable.vue";
import SmartSelect from "../../components/SmartSelect.vue";
import SmartSearch from "../../components/SmartSearch.vue";
import ModalDelete from "../../components/ModalDelete.vue";

export default {
	components: {
		//   LTable,
		//   ChartCard,
		//   StatsCard
		"datatable": Datatable,
		"smart-select": SmartSelect,
		"smart-search": SmartSearch,
		"modal-delete": ModalDelete
	},
	data() {
		return {
			base_ppn:11,
			currentPage: 1,
			perPage: null,
			rowLimit: 10,
			nextUrl: null,
			prevUrl: null,
			role: "",
			selectedDetail: 0,
			newairtimediskonlabel: "",
			newairtimepricelabel: "",
			selectedHardwareSetup: {},
			newhardwareidlabel: "",
			isMobile: false,
			itemToDelete: {},
			invoiceairtimes: [],
			histories: [],
			searchValue: "",
			loadData: true,
			loadHistoriesData: true,
			savingNewInvoiceAirtime: false,
			errorNewInvoiceAirtime: false,
			errorInvoiceItemList: [],
			existingClientResult: [],
			newInvoiceAirtimeSaved: false,
			selectedTab: 0,
			newHardwarePrice: 0,
			newAirtimePrice: 0,
			updateAirtimePrice: 0,
			newDiscount: 0,
			updateDiscount: 0,
			selectedIdforEdit: 0,
			updateSaved: false,
			errorUpdate: false,
			updating: false,
			deleteId: 0,
			// deleteTargetId:0,
			newInvoiceAirtime: {
				invoiceNo: "",
				invoiceItemMetadataId: "",
				proforma: "no",
				startPeriod: "",
				invoiceDate: new Date(),
				dueDateInvoice: "",
				airtimePriceId: "",
				airtimePrice: 0,
				airtimeMonthDuration: "",
				discount: 0,
				discountId: 0,
				id_bank:'',
				label_bank:'',
				subtotal: 0,
				total: 0,
				totalPPN: 0,
				// ppn: "no",
				ppn: "yes",
				notes: "",
				pic: "Dewi",
				division: "Finance Manager",
				qrCode: "yes"
			},
			formInvoiceAirtimeActive: false,
			historyTableStructure: [
				{label: "No", key: null},
				{
					label: {
						id: "Nama admin",
						en: "Admin name"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal perubahan",
						en: "Updated at"
					},
					key: null
				},
				{
					label: {
						id: "Nomor Invoice",
						en: "Invoice number"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal Invoice",
						en: "Invoice date"
					},
					key: null
				},
				{
					label: {
						id: "Tanggal invoice jatuh tempo",
						en: "Invoice due date"
					},
					key: null
				},
				{
					label: {
						id: "Jabatan",
						en: "Position"
					},
					key: null
				},
				{
					label: {
						id: "PIC",
						en: "PIC"
					},
					key: null
				}
			],
			tableStructure: [
				//label: nama heading, key: nama object property
				{label: "No", key: null},
				{label: "Nomor Invoice", key: null},
				{label: "Nama", key: null},
				{label: "NPWP", key: null},
				{label: "Tanggal Invoice", key: null},
				{label: "Tanggal Mulai", key: null},
				{label: "Tanggal Selesai", key: null},
				{label: "Nama Kapal", key: null},
				{label: "SAP", key: null},
				{label: "Tindakan", key: null}
			],
			proformaTypeOptions: [
				{label: "Tidak", value: "no"},
				{label: "Ya", value: "yes"}
			],
			qrCodeTypeOptions: [
				{label: "Ya", value: "yes"},
				{label: "Tidak", value: "no"}
			],
			ppnTypeOptions: [
				// {label: "Ya", value: "yes"},
				{label: "Ya", value: "yes"},
				{label: "Tidak", value: "no"}
			]
			// airtimeTypeOptions:[
			//     {label:'Ya',value:'yes'},
			//     {label:'Tidak',value:'no'},
			// ],
		};
	},
	created() {
		this.role = localStorage.getItem("role");
		this.$reActivateAccess(this); /*SETTIMEOUT LOGOUT OTOMATIS, (this,true) UTK MELIHAT DETIK DI BROWSHER*/
		this.getInvoiceAirtimes();
		this.getHistories();
		// var newData = [];
		// for(var x=0;x<100;x++){
		//     newData.push({id:x,name:'nama_'+x,username:'nama'+x,role:'user'});
		// }
		// console.log(newData);
		// this.users = newData;
		this.getNoInvoice();
		this.getSetPpn();
	},
	methods: {
		// getSetPpn(){
		// 	axios.get(this.$baseUrl + "/api/setting?key=ppn", {
		// 		"headers": {
		// 			"Authorization": "Bearer " + localStorage.getItem("accessToken")
		// 		}
		// 	}).then((result) => {
		// 		console.log(result);
		// 		this.base_ppn = result.data.value;
	            // result.data.forEach((data)=>{
	            // 	this.ppnTypeOptions.push({label:data.value+' %',value:data.value})
	            // })
			// 	console.log(this.base_ppn);
			// }).catch((err) => {
				//check if token fail
			// });
		// },
		getNoInvoice(){
			axios.get(this.$baseUrl + "/api/pemesanan/no_invoice/invoice-airtime", {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.newInvoiceAirtime.invoiceNo = result.data.create;
			}).catch((err) => {
				//check if token fail
			});
		},
		changePage(isNext) {
			var url = (isNext ? this.nextUrl : this.prevUrl);
			let params = (new URL(url)).searchParams;
			const myParams = params.get("page");
			this.currentPage = myParams;
			var newUrl = this.$baseUrl + "/api/pemesanan/invoice-airtime?limit=" + this.rowLimit + "&page=" + myParams;
			this.getInvoiceAirtimes(newUrl);
		},
		resetNewInvoice() {
			this.newInvoiceAirtime.invoiceNo = "";
			this.newInvoiceAirtime.invoiceItemMetadataId = "";
			this.newInvoiceAirtime.proforma = "no";
			this.newInvoiceAirtime.startPeriod = "";
			this.newInvoiceAirtime.invoiceDate = new Date();
			this.newInvoiceAirtime.dueDateInvoice = "";
			this.newInvoiceAirtime.airtimePriceId = "";
			this.newInvoiceAirtime.id_bank = "";
			this.newInvoiceAirtime.label_bank = "";
			this.newInvoiceAirtime.airtimePrice = 0;
			this.newInvoiceAirtime.airtimeMonthDuration = "";
			this.newInvoiceAirtime.discount = 0;
			this.newInvoiceAirtime.discountId = 0;
			this.newInvoiceAirtime.subtotal = 0;
			this.newInvoiceAirtime.total = 0;
			this.newInvoiceAirtime.totalPPN = 0;
			// this.newInvoiceAirtime.ppn = "no";
			this.newInvoiceAirtime.ppn = "yes";
			this.newInvoiceAirtime.notes = "";
			this.newInvoiceAirtime.pic = "";
			this.newInvoiceAirtime.division = "";
			this.newInvoiceAirtime.qrCode = "no";
			this.newhardwareidlabel = "";
			this.selectedHardwareSetup = {};
			this.newairtimepricelabel = "";
			this.newairtimediskonlabel = "";
		},
		getInvoiceAirtimes(url = (this.$baseUrl + "/api/pemesanan/invoice-airtime?limit=" + this.rowLimit)) {
			this.loadData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.prevUrl = result.data.prev_page_url;
				this.nextUrl = result.data.next_page_url;
				this.currentPage = result.data.current_page;
				this.perPage = parseInt(result.data.per_page);
				this.invoiceairtimes = result.data.data;
				this.loadData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadData = false;
			});
		},
		// translatePPN(data) {
		// 	var label = "";
		// 	switch (data.ppn) {
				// case "yes":
				// 	label = "Ya";
				// 	break;
		// 		case "no":
		// 			label = "Tidak";
		// 			break;
		// 		default:
		// 			label = data.ppn_number+'%';
		// 			break;
		// 	}
		// 	return label;
		// },
		getHistories(id) {
			var url = this.$baseUrl + "/api/report/json/invoice-airtime-history/" + id;
			this.loadHistoriesData = true;
			axios.get(url, {
				"headers": {
					"Authorization": "Bearer " + localStorage.getItem("accessToken")
				}
			}).then((result) => {
				console.log(result);
				this.histories = result.data;
				this.loadHistoriesData = false;
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				console.log(err);
				this.loadHistoriesData = false;
			});
		},

		deleteResult(deleted) {
			console.log(deleted);
			if (deleted) {
				this.getInvoiceAirtimes();
			}
		},
		// getDeleteUrl(){
		//   return '/api/pemesanan/invoice/'+this.deleteTargetId;
		// },
		// deleteItem(item){
		//     this.deleteTargetId = item.id
		// },
		calculateAmount() {
			if (this.newInvoiceAirtime.airtimePrice > 0) {
				if (this.newDiscount.discount_type != undefined) {
					if (this.newDiscount.discount_type == "nominal") {
						this.newInvoiceAirtime.discount = this.newDiscount.price;
					} else {
						if (this.newInvoiceAirtime.airtimePrice > 0) {
							this.newInvoiceAirtime.discount = this.newInvoiceAirtime.airtimePrice * this.newDiscount.price / 100;
						}
					}
				} else {
					this.newInvoiceAirtime.discount = 0;
				}
				console.log(console.log("diskon" + this.newInvoiceAirtime.discount));
				this.newInvoiceAirtime.subtotal = parseInt(this.newInvoiceAirtime.airtimePrice) - parseInt(this.newInvoiceAirtime.discount);
				// if (this.newInvoiceAirtime.ppn != "no") {
				// 	this.newInvoiceAirtime.totalPPN = Math.round((this.newInvoiceAirtime.subtotal * (this.newInvoiceAirtime.ppn/100)));
				// 	this.newInvoiceAirtime.total = Math.round((this.newInvoiceAirtime.subtotal + this.newInvoiceAirtime.totalPPN) / 10) * 10;
				// 	console.log(this.totalPPN);
				if (this.newInvoiceAirtime.ppn == "yes") {
					this.newInvoiceAirtime.totalPPN = Math.round((this.newInvoiceAirtime.subtotal * (this.base_ppn/100)));
					this.newInvoiceAirtime.total = Math.round((this.newInvoiceAirtime.subtotal + this.newInvoiceAirtime.totalPPN) / 10) * 10;
					console.log(this.totalPPN);
				} else {
					this.newInvoiceAirtime.total = this.newInvoiceAirtime.subtotal;
					this.newInvoiceAirtime.totalPPN = 0;
				}
				console.log(console.log("subtotal" + this.newInvoiceAirtime.subtotal));
			} else {
				this.newInvoiceAirtime.subtotal = 0;
			}
		},
		calculateUpdateAmount() {
			if (this.invoiceairtimes[this.selectedIdforEdit].airtime_price > 0) {
				if (this.updateDiscount.discount_type != undefined) {
					if (this.updateDiscount.discount_type == "nominal") {
						this.invoiceairtimes[this.selectedIdforEdit].discount = data.price;
					} else {
						if (this.invoiceairtimes[this.selectedIdforEdit].airtime_price > 0) {
							this.invoiceairtimes[this.selectedIdforEdit].discount = this.invoiceairtimes[this.selectedIdforEdit].airtime_price * this.updateDiscount.price / 100;
						}
					}
				}
				// var discount = (this.invoiceairtimes[this.selectedIdforEdit].discount != null?this.invoiceairtimes[this.selectedIdforEdit].discount:0);
				// this.invoiceairtimes[this.selectedIdforEdit].subtotal = parseInt(this.invoiceairtimes[this.selectedIdforEdit].airtime_price) - parseInt(discount);
				this.invoiceairtimes[this.selectedIdforEdit].subtotal = parseInt(this.invoiceairtimes[this.selectedIdforEdit].airtime_price) - parseInt(
				this.invoiceairtimes[this.selectedIdforEdit].discount);
				var ppn = 0;
				// if (this.invoiceairtimes[this.selectedIdforEdit].ppn != "no") {
				// 	ppn = this.invoiceairtimes[this.selectedIdforEdit].subtotal * (this.invoiceairtimes[this.selectedIdforEdit].ppn_number/100);
				// }
				if (this.invoiceairtimes[this.selectedIdforEdit].ppn == "yes") {
				ppn = this.invoiceairtimes[this.selectedIdforEdit].subtotal * (this.base_ppn/100);
				// console.log(ppn);
				this.invoiceairtimes[this.selectedIdforEdit].total = this.invoiceairtimes[this.selectedIdforEdit].subtotal + ppn;

				} else {
					this.invoiceairtimes[this.selectedIdforEdit].subtotal = 0;
				}
			}
		},
		updateNewIiProforma(data) {
			this.newInvoiceAirtime.proforma = data;
		},
		updateNewQrCode(data) {
			this.newInvoiceAirtime.qrCode = data;
		},
		// updateEditPPN(value){
        //   	this.invoiceairtimes[this.selectedIdforEdit].ppn_number=(value != "no" ? value : 0);
          	// this.invoiceairtimes[this.selectedIdforEdit].ppn=(value != "no" ? "yes" : "no");
        //   	console.log(this.invoiceairtimes[this.selectedIdforEdit])
		// },
		updateNewPpn(data) {
			this.newInvoiceAirtime.ppn = data;
			this.calculateAmount();
		},
		updateNewIiAirtime(data) {
			this.newInvoiceAirtime.airtime = data;
		},
		savenewInvoiceAirtime() {
			this.savingNewInvoiceAirtime = true;
			this.errorNewInvoiceAirtime = false;
			console.log(this.newInvoiceAirtime);
			if (
				this.newInvoiceAirtime.invoiceNo != "" &&
				this.newInvoiceAirtime.invoiceItemMetadataId != "" &&
				this.newInvoiceAirtime.startPeriod != "" &&
				this.newInvoiceAirtime.invoiceDate != "" &&
				this.newInvoiceAirtime.dueDateInvoice != "" &&
				this.newInvoiceAirtime.airtimePriceId != "" &&
				this.newInvoiceAirtime.airtimeMonthDuration != "" &&
				this.newInvoiceAirtime.total != ""
			) {
				axios.post(
					this.$baseUrl + "/api/pemesanan/invoice-airtime",
					{
						"invoice_no": this.newInvoiceAirtime.invoiceNo,
						"invoice_item_metadata_id": this.newInvoiceAirtime.invoiceItemMetadataId,
						"start_period": this.newInvoiceAirtime.startPeriod,
						"invoice_date": this.newInvoiceAirtime.invoiceDate,
						"due_date_invoice": this.newInvoiceAirtime.dueDateInvoice,
						"proforma": this.newInvoiceAirtime.proforma,
						"qr_code": this.newInvoiceAirtime.qrCode,
						"ppn": this.newInvoiceAirtime.ppn,
						"airtime_price_id": this.newInvoiceAirtime.airtimePriceId,
						"airtime_price": this.newInvoiceAirtime.airtimePrice,
						"airtime_month_duration": this.newInvoiceAirtime.airtimeMonthDuration,
						"discount": this.newInvoiceAirtime.discount,
						"discount_id": this.newInvoiceAirtime.discountId,
						"pic": this.newInvoiceAirtime.pic,
						"id_bank": this.newInvoiceAirtime.id_bank,
						"division": this.newInvoiceAirtime.division,
						"total": this.newInvoiceAirtime.total,
						"notes": this.newInvoiceAirtime.notes,
						"end_periode":this.newInvoiceAirtime.endPeriode
					},
					{
						"headers":
							{
								"Authorization": "Bearer " + localStorage.getItem("accessToken")
							}
					}
				).then((result) => {
					console.log(result);
					this.savingNewInvoiceAirtime = false;
					this.newInvoiceAirtimeSaved = true;
					this.resetNewInvoice();
					this.getInvoiceAirtimes();
					setTimeout(() => {
						this.formInvoiceAirtimeActive = false;
						this.newInvoiceAirtimeSaved = false;
					}, 1000);
				}).catch((err) => {
					//check if token fail
					if (err.response && err.response.status == 401) {
						localStorage.removeItem("accessToken");
						this.$router.push("/login");
					}
					console.clear();
					console.log(err.response);
					this.savingNewInvoiceAirtime = false;
					this.errorNewInvoiceAirtime = true;
				});
			} else {
				console.log("data invalid");
				this.errorNewInvoiceAirtime = true;
			}
		},
		updateInvoiceAirtime() {
			this.updating = true;
			this.errorUpdate = false;
          	// this.invoiceairtimes[this.selectedIdforEdit].ppn=(this.invoiceairtimes[this.selectedIdforEdit].ppn != "no" ? "yes" : "no");
			axios.put(
				this.$baseUrl + "/api/pemesanan/invoice-airtime/" + this.invoiceairtimes[this.selectedIdforEdit].id,
				this.invoiceairtimes[this.selectedIdforEdit],
				{
					headers: {"Authorization": "Bearer " + localStorage.getItem("accessToken")}
				}
			).then((result) => {
				if (result.status = 200) {
					this.updating = false;
					this.updateSaved = true;
					setTimeout(() => {
						this.updateSaved = false;
						this.$bvModal.hide("modal-edit-invoice");
					}, 1000);
				}
				console.log(result);
			}).catch((err) => {
				//check if token fail
				if (err.response && err.response.status == 401) {
					localStorage.removeItem("accessToken");
					this.$router.push("/login");
				}
				this.updating = false;
				this.errorUpdate = true;
				console.log(err.response);
			});
		},
		newUsernameChange() {
			this.newInvoiceAirtime.password = this.newInvoiceAirtime.username.toUpperCase();
		},
		deleteItem(item) {
			console.log("button delete untuk user id: " + item.id);
		},
		updateUserRoleValue(newValue) {
			this.newInvoiceAirtime.role = newValue;
		},
		setNewClientId(newId) {
			this.newInvoiceAirtime.clientId = newId;
			console.log(this.newInvoiceAirtime.clientId);
		},
		smartSearchAddIdTransmitter(data) {
			this.newInvoiceAirtime.invoiceItemMetadataId = data.order_metadata.invoice_item_metadata.id;
			this.selectedHardwareSetup = data;
		},
		smartSearchHardwarePrice(data) {
			// this.newInvoiceAirtime.price_hardware=data.id
			this.newHardwarePrice = data.price;
			this.calculateAmount();
		},
		smartSearchAirtimePrice(data) {
			this.newInvoiceAirtime.airtimePrice = data.price;
			this.newInvoiceAirtime.airtimeMonthDuration = data.month_duration;
			this.newInvoiceAirtime.airtimePriceId = data.id;
			this.newAirtimePrice = data;
			this.$forceUpdate();
			this.calculateAmount();
		},
		smartSearchUpdateAirtimePrice(data) {
			this.invoiceairtimes[this.selectedIdforEdit].airtime_price = data.price;
			this.invoiceairtimes[this.selectedIdforEdit].airtime_month_duration = data.month_duration;
			this.invoiceairtimes[this.selectedIdforEdit].airtime_price_id = data.id;
			this.updateAirtimePrice = data;
			this.$forceUpdate();
			this.calculateUpdateAmount();
		},
		smartSearchDiscount(data) {
			if (data == null) {
				this.newInvoiceAirtime.discount = 0;
				this.newInvoiceAirtime.discountId = 0;
				this.newDiscount = {};
				this.$forceUpdate();
				return;
			}

			this.newInvoiceAirtime.discountId = data.id;
			this.newInvoiceAirtime.discount = data.price;
			this.newDiscount = data;
			this.$forceUpdate();
			this.calculateAmount();
		},
		smartSearchUpdateDiscount(data) {
			if (data == null) {
				this.invoiceairtimes[this.selectedIdforEdit].discount = 0;
				this.invoiceairtimes[this.selectedIdforEdit].discount_id = "";
				this.updateDiscount = {};
				this.$forceUpdate();
				return;
			}

			this.invoiceairtimes[this.selectedIdforEdit].discount_id = data.id;
			this.invoiceairtimes[this.selectedIdforEdit].discount = data.price;
			this.updateDiscount = data;
			this.$forceUpdate();
			this.calculateUpdateAmount();
		},
		updateKapal(data) {
			console.log(data.kapal_id.id);
			this.newInvoiceAirtime.vessel_id = data.kapal_id.id;
		}

	}
};
</script>
<style scoped>
.btn {
	padding: 2px 6px;
}

/* ::v-deep .modal.show .modal-dialog {
    transform: translate(0px, 10%);
}
::v-deep .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 1rem);
} */
.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td {
	width: 50%;
}
</style>
